import React, { useContext, useState } from 'react';
import { GameContext } from '../contexts/GameContext';
import { GAME_STATE } from '../utils/constants';
import Instructions from './Instructions';

const GameControls = () => {
  const { 
    gameState, 
    currency, 
    startBattle, 
    initializeGame,
    stageInfo,
    battleLinePosition,
    units
  } = useContext(GameContext);
  
  const [showInstructions, setShowInstructions] = useState(false);

  return (
    <>
      {/* Top fixed bar with game info */}
      <header className="bg-gray-800 border-b-2 border-green-600 py-2 px-4 flex justify-between items-center">
        <div className="flex items-center text-white">
          <div className="flex items-center mx-2">
            <span className="mr-1">💰</span>
            <span>{currency}</span>
          </div>
          
          {stageInfo && (
            <>
              <div className="flex items-center mx-2">
                <span className="mr-1">🏆</span>
                <span>Level {stageInfo.levelNumber}/{stageInfo.totalLevels}</span>
              </div>
              <div className="flex items-center mx-2">
                <span className="mr-1">🎯</span>
                <span>Stage {stageInfo.stageNumber}/{stageInfo.totalStages}</span>
              </div>
            </>
          )}
          
          <div className="flex items-center mx-2">
            <span className="mr-1">⚔️</span>
            <span>Line {Math.round(battleLinePosition)}%</span>
          </div>
        </div>
        
        <div className="flex items-center">
          <button 
            onClick={() => setShowInstructions(true)}
            className="flex items-center text-white bg-gray-600 px-3 py-1 rounded mr-2 hover:bg-gray-500"
          >
            <span>Help</span>
          </button>
          
          {gameState === GAME_STATE.PLACEMENT && (
            <button 
              onClick={startBattle}
              className="bg-green-600 text-white px-4 py-2 rounded font-bold"
              disabled={units.red.length === 0}
            >
              Start Battle
            </button>
          )}
          
          <button 
            onClick={initializeGame}
            className="bg-red-600 text-white px-3 py-1 rounded ml-2 font-bold"
          >
            Reset
          </button>
        </div>
      </header>
      
      {/* Instructions Modal */}
      {showInstructions && (
        <div className="fixed inset-0 bg-black bg-opacity-70 flex items-center justify-center z-50 p-4">
          <div className="bg-gray-800 w-full max-w-2xl max-h-[80vh] overflow-auto rounded-lg border-2 border-green-600">
            <div className="flex justify-between items-center p-4 border-b border-green-600">
              <h2 className="text-xl font-bold text-white">Game Instructions</h2>
              <button 
                onClick={() => setShowInstructions(false)}
                className="text-white hover:text-red-400"
              >
                ✕
              </button>
            </div>
            
            <div className="p-4 text-white">
              <Instructions />
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default GameControls;